import jwtDecode from 'jwt-decode';

import { deleteCookie, getCookie, setCookie } from './cookie';
import { logError } from './log';

import type { TokenDecodedData } from 'types';

type StringUndefinedNull = string | undefined | null;

const COOKIE_ACCESS_TOKEN = 'accessToken';
const COOKIE_REFRESH_TOKEN = 'refreshToken';

function getToken(type): StringUndefinedNull {
  return getCookie(type);
}

function setToken(type, token): void {
  if (!token) {
    deleteCookie(type);
    return;
  }

  setCookie(type, token);
}

export function decodeToken(token): TokenDecodedData | null {
  let decodedData = null;

  if (!token) {
    return decodedData;
  }

  try {
    decodedData = jwtDecode(token);
  } catch (err) {
    logError(err);
  }

  return decodedData;
}

export function getAccessToken(): StringUndefinedNull {
  return getToken(COOKIE_ACCESS_TOKEN);
}

export function getRefreshToken(): StringUndefinedNull {
  return getToken(COOKIE_REFRESH_TOKEN);
}

export function forgetTokens(): void {
  deleteCookie(COOKIE_ACCESS_TOKEN);
  deleteCookie(COOKIE_REFRESH_TOKEN);
}

export function setTokens(tokens): void {
  if (!tokens) {
    forgetTokens();
    return;
  }

  setToken(COOKIE_ACCESS_TOKEN, tokens.accessToken);
  setToken(COOKIE_REFRESH_TOKEN, tokens.refreshToken);
}

export function hasAccessToken(): boolean {
  return Boolean(getAccessToken());
}
